export default {
  motivoIncorrida: {
    value: '',
    maxlength: '500',
    required: false,
    rows: '3',
    noResize: true
  }
}



// WEBPACK FOOTER //
// ./src/views/private/finance/expenses/miscellaneous/details/components/modal/disapproved/modalDisapproved-form.js